import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              最新动态
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              片源更新、功能升级、专题上线，掌握一手资讯
            </p>
          </div>
        </div>

        <div className="max-w-[900px] mx-auto">
          {updatesData.map((item, idx) => (
            <div
              key={item.id}
              className={`relative flex gap-4 md:gap-6 ${
                idx < updatesData.length - 1 ? 'pb-5 md:pb-6' : ''
              }`}
            >
              <div className="flex flex-col items-center">
                <span
                  className={`w-2.5 h-2.5 rounded-full flex-shrink-0 mt-1.5 ${
                    idx === 0 ? 'bg-accent-500' : 'bg-background-300'
                  }`}
                ></span>
                {idx < updatesData.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-1.5"></div>
                )}
              </div>
              <div className={`flex-1 pb-1 ${
                idx === updatesData.length - 1 ? '' : 'border-b border-background-200/60 pb-4 md:pb-5'
              }`}>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                  <span className="text-[11px] bg-secondary-100/80 text-secondary-700 px-2 py-0.5 rounded-full font-medium w-fit whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1.5 text-sm md:text-base text-foreground-700">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}